/**
 * Redux store partition definition.
 */
export default {
    /**
     * Store partition key.
     */
    Key: 'NOTIFICATION',

    /**
     * Action types
     */
    Type: {
        EXEC: 'NOTIFICATION-EXEC',
        COMMIT: 'NOTIFICATION-COMMIT',
        ROLLBACK: 'NOTIFICATION-ROLLBACK'
    },

    /**
     * Partition states.
     */
    State: {
        PREPARING: 'PREPARING',
        EXECUTING: 'EXECUTING',
        READY: 'READY',
        FAILED: 'FAILED'
    }
};
